/* cuqui-motion.js — con guards anti-freeze:
 * - respeta prefers-reduced-motion
 * - pausa rAFs cuando tab no visible
 * - cancela rAFs al pagehide/beforeunload
 */
(function() {
  var CQ_REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (CQ_REDUCED) { return; /* usuario prefiere sin movimiento */ }
  var CQ_ACTIVE_RAFS = [];
  var CQ_ORIG_RAF = window.requestAnimationFrame.bind(window);
  var CQ_PAUSED = false;
  // Interceptar rAF para poder cancelar todos al hide
  var CQ_RAF = function(cb) {
    if (CQ_PAUSED) return -1;
    var id = CQ_ORIG_RAF(function(ts) {
      var idx = CQ_ACTIVE_RAFS.indexOf(id);
      if (idx >= 0) CQ_ACTIVE_RAFS.splice(idx, 1);
      cb(ts);
    });
    CQ_ACTIVE_RAFS.push(id);
    return id;
  };
  window.__cqRAF = CQ_RAF;
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      CQ_PAUSED = true;
      CQ_ACTIVE_RAFS.forEach(function(id) { window.cancelAnimationFrame(id); });
      CQ_ACTIVE_RAFS = [];
    } else {
      CQ_PAUSED = false;
    }
  });
  window.addEventListener('pagehide', function() {
    CQ_PAUSED = true;
    CQ_ACTIVE_RAFS.forEach(function(id) { window.cancelAnimationFrame(id); });
    CQ_ACTIVE_RAFS = [];
  });
})();

(function() {
  if (typeof window === 'undefined') return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = window.matchMedia && window.matchMedia('(pointer: fine) and (min-width: 990px)').matches;

  function init() {
    // ===== 1. Scroll progress bar =====
    if (!reduce) {
      var bar = document.createElement('div');
      bar.className = 'cq-scroll-progress';
      bar.innerHTML = '<div class="cq-scroll-progress__fill"></div>';
      document.body.appendChild(bar);
      var fill = bar.querySelector('.cq-scroll-progress__fill');
      function updateProgress() {
        var h = document.documentElement;
        var st = window.scrollY || h.scrollTop;
        var sh = h.scrollHeight - h.clientHeight;
        var pct = sh > 0 ? (st / sh * 100) : 0;
        fill.style.width = pct + '%';
      }
      var _cqProgTick = false;
      window.addEventListener('scroll', function() { if (!_cqProgTick) { _cqProgTick = true; requestAnimationFrame(function() { updateProgress(); _cqProgTick = false; }); } }, { passive: true });
      updateProgress();
    }

    // ===== 2. IntersectionObserver reveals =====
    if ('IntersectionObserver' in window) {
      var selectors = [
        '[data-cq-reveal]',
        '.valores-cuqui__item',
        '.atelier-cuqui__text',
        '.atelier-cuqui__media',
        '.atelier-cuqui__eyebrow',
        '.atelier-cuqui__heading',
        '.atelier-cuqui__body',
        '.atelier-cuqui__button',
        '.trabajos-cuqui__item',
        '.trabajos-cuqui__head',
        '.cq-clip-reveal'
      ];
      var elements = document.querySelectorAll(selectors.join(','));
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -80px 0px' });
      elements.forEach(function(el) { io.observe(el); });
    }

    // ===== 3. Hero title split-words reveal =====
    if (!reduce) {
      var heroTitle = document.querySelector('.hero-cuqui-full__heading');
      if (heroTitle && !heroTitle.dataset.cqSplit) {
        heroTitle.dataset.cqSplit = '1';
        var t = heroTitle.textContent.trim();
        heroTitle.innerHTML = '';
        var words = t.split(' ');
        words.forEach(function(w, i) {
          var s = document.createElement('span');
          s.className = 'cq-word';
          s.textContent = w;
          heroTitle.appendChild(s);
          if (i < words.length - 1) heroTitle.appendChild(document.createTextNode(' '));
        });
        setTimeout(function() { heroTitle.classList.add('cq-revealed'); }, 150);
      }
    }

    // ===== 4. Parallax hero + atelier (lerp smooth) =====
    if (!reduce && window.matchMedia('(min-width: 750px)').matches) {
      var hero = document.querySelector('.hero-cuqui-full');
      var atelier = document.querySelector('.atelier-cuqui');
      var heroTarget = 0, heroCurrent = 0;
      var atelTarget = 0, atelCurrent = 0;
      var ticking = false;

      // Metricas cacheadas: leidas SOLO en load/resize, nunca por frame de scroll.
      // (antes: getBoundingClientRect()+offsetTop por frame = reflow sincrono = freeze desktop)
      var vh = window.innerHeight;
      var heroTop = 0, heroH = 0, atelTop = 0, atelH = 0;
      function measure() {
        vh = window.innerHeight;
        if (hero) { heroTop = hero.offsetTop; heroH = hero.offsetHeight; }
        if (atelier) { atelTop = atelier.offsetTop; atelH = atelier.offsetHeight; }
      }

      function calcTargets() {
        // Sin lecturas de layout: todo derivado de scrollY + metricas cacheadas.
        var y = window.scrollY || window.pageYOffset;
        if (hero && heroTop < y + vh && (heroTop + heroH) > y) {
          heroTarget = (y - heroTop) * 0.35;
        }
        if (atelier && atelTop < y + vh && (atelTop + atelH) > y) {
          var center = (atelTop - y) + atelH / 2 - vh / 2;
          atelTarget = -center * 0.10;
        }
      }

      // Event-driven: solo corre cuando hay actividad de scroll
      var parallaxActive = false;
      var idleTimer = null;
      function loop() {
        var dh = heroTarget - heroCurrent;
        var da = atelTarget - atelCurrent;
        heroCurrent += dh * 0.10;
        atelCurrent += da * 0.10;
        if (hero) hero.style.setProperty('--cq-hero-parallax', heroCurrent.toFixed(1));
        if (atelier) atelier.style.setProperty('--cq-atel-parallax', atelCurrent.toFixed(1));
        // Detener cuando ya está prácticamente en su target Y no hay input reciente
        if (Math.abs(dh) < 0.3 && Math.abs(da) < 0.3 && !parallaxActive) {
          return; // idle → stop
        }
        (window.__cqRAF || requestAnimationFrame)(loop);
      }
      function wakeParallax() {
        if (!parallaxActive) {
          parallaxActive = true;
          loop();
        }
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function(){ parallaxActive = false; }, 200);
      }

      window.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(function() {
            calcTargets();
            ticking = false;
            wakeParallax();
          });
          ticking = true;
        }
      }, { passive: true });
      // Remedir en resize (debounced) y tras load (imagenes decodificadas mueven offsets).
      var _cqMeasureT = null;
      window.addEventListener('resize', function() {
        clearTimeout(_cqMeasureT);
        _cqMeasureT = setTimeout(function() { measure(); calcTargets(); wakeParallax(); }, 150);
      }, { passive: true });
      window.addEventListener('load', function() { measure(); calcTargets(); }, { once: true });
      measure();
      calcTargets();
      // NO auto-start del loop — solo corre con scroll
      wakeParallax();
    }

    // ===== 5. Header scrolled state (background blur) =====
    var hw = document.querySelector('.header-wrapper');
    if (hw) {
      function checkScroll() {
        if ((window.scrollY || window.pageYOffset) > 40) hw.classList.add('cq-scrolled');
        else hw.classList.remove('cq-scrolled');
      }
      var hdrTick = false;
      window.addEventListener('scroll', function() {
        if (hdrTick) return;
        hdrTick = true;
        requestAnimationFrame(function() { checkScroll(); hdrTick = false; });
      }, { passive: true });
      checkScroll();
    }

    // ===== 6. Magnetic buttons =====
    if (!reduce && isDesktop) {
      var magnetic = document.querySelectorAll('.hero-cuqui-full__button, .atelier-cuqui__button, .trabajos-cuqui__viewall');
      magnetic.forEach(function(btn) {
        btn.addEventListener('mousemove', function(e) {
          var rect = btn.getBoundingClientRect();
          var x = e.clientX - rect.left - rect.width / 2;
          var y = e.clientY - rect.top - rect.height / 2;
          btn.style.transform = 'translate(' + (x * 0.18) + 'px, ' + (y * 0.18 - 2) + 'px)';
        });
        btn.addEventListener('mouseleave', function() {
          btn.style.transform = '';
        });
      });
    }

    // ===== 7. Custom cursor + trail =====
    if (!reduce && isDesktop) {
      var cursor = document.createElement('div');
      cursor.className = 'cq-cursor';
      document.body.appendChild(cursor);

      // Trail of 6 small dots
      var trail = [];
      for (var i = 0; i < 6; i++) {
        var d = document.createElement('div');
        d.className = 'cq-trail';
        document.body.appendChild(d);
        trail.push({ el: d, x: 0, y: 0 });
      }

      var cx = 0, cy = 0, tx = 0, ty = 0;
      var visible = false;
      var cursorActive = false, cursorRunning = false, cursorIdle = null;
      function wakeCursor() {
        cursorActive = true;
        clearTimeout(cursorIdle);
        cursorIdle = setTimeout(function(){ cursorActive = false; }, 100);
        if (!cursorRunning) { cursorRunning = true; loop(); }
      }
      document.addEventListener('mousemove', function(e) {
        tx = e.clientX; ty = e.clientY;
        if (!visible) {
          cursor.classList.add('is-active');
          trail.forEach(function(t) { t.el.style.opacity = '0.5'; });
          visible = true;
        }
        wakeCursor();
      }, { passive: true });
      document.addEventListener('mouseleave', function() {
        cursor.classList.remove('is-active');
        trail.forEach(function(t) { t.el.style.opacity = '0'; });
        visible = false;
      });

      function loop() {
        cx += (tx - cx) * 0.20;
        cy += (ty - cy) * 0.20;
        cursor.style.transform = 'translate(' + cx + 'px, ' + cy + 'px) translate(-50%, -50%)';
        // Trail lerp
        var maxd = Math.abs(tx - cx) + Math.abs(ty - cy);
        for (var i = 0; i < trail.length; i++) {
          var prev = i === 0 ? { x: cx, y: cy } : trail[i-1];
          trail[i].x += (prev.x - trail[i].x) * 0.32;
          trail[i].y += (prev.y - trail[i].y) * 0.32;
          maxd += Math.abs(prev.x - trail[i].x) + Math.abs(prev.y - trail[i].y);
          trail[i].el.style.transform = 'translate(' + trail[i].x + 'px, ' + trail[i].y + 'px) translate(-50%, -50%)';
          trail[i].el.style.opacity = visible ? String(0.45 - i * 0.06) : '0';
        }
        // Parar el rAF cuando el cursor esta quieto y no hay input reciente.
        // (antes: loop infinito cada frame tras el primer mousemove = jank permanente)
        if (maxd < 0.5 && !cursorActive) { cursorRunning = false; return; }
        (window.__cqRAF || requestAnimationFrame)(loop);
      }

      var hoverTargets = 'a, button, .valores-cuqui__item, .trabajos-cuqui__item, [role="button"]';
      document.addEventListener('mouseover', function(e) {
        if (e.target.closest(hoverTargets)) cursor.classList.add('is-hover');
      });
      document.addEventListener('mouseout', function(e) {
        if (e.target.closest(hoverTargets)) cursor.classList.remove('is-hover');
      });
    }

    // ===== 8. Atelier heading split-word ===== 
    if (!reduce) {
      var atelTitle = document.querySelector('.atelier-cuqui__heading');
      if (atelTitle && !atelTitle.dataset.cqSplit) {
        atelTitle.dataset.cqSplit = '1';
        var t2 = atelTitle.textContent.trim();
        atelTitle.innerHTML = '';
        var ws = t2.split(' ');
        ws.forEach(function(w, i) {
          var s = document.createElement('span');
          s.style.cssText = 'display:inline-block;opacity:0;transform:translateY(30px);transition:opacity 900ms var(--cq-ease-out) ' + (i * 90) + 'ms,transform 900ms var(--cq-ease-out) ' + (i * 90) + 'ms;';
          s.textContent = w;
          atelTitle.appendChild(s);
          if (i < ws.length - 1) atelTitle.appendChild(document.createTextNode(' '));
        });
        if ('IntersectionObserver' in window) {
          var titleIo = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                var spans = entry.target.querySelectorAll('span');
                spans.forEach(function(sp) { sp.style.opacity = '1'; sp.style.transform = 'translateY(0)'; });
                titleIo.unobserve(entry.target);
              }
            });
          }, { threshold: 0.3 });
          titleIo.observe(atelTitle);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
